import { BaseTool } from '@blocksuite/std/gfx';

import type { NavigatorMode } from './frame-manager';

export type PresentToolOption = {
  mode?: NavigatorMode;
  restoredAfterPan?: boolean;
  /**
   * When true, this is a follower in a collaborative presentation.
   * Follower mode:
   * - Disables keyboard navigation (ArrowLeft/Right)
   * - Frame index is controlled externally via navigatorSetFrame slot
   * - UI shows only display, no controls
   */
  followerMode?: boolean;
};

export class PresentTool extends BaseTool<PresentToolOption> {
  static override toolName: string = 'frameNavigator';
}
